import { post, get } from '$fetch'

/**
 * @desc 报名合伙人，提交手机号
 * @param {*} phone: 手机号
 * @returns
 */
export const addPartner = params => post('/intent/ark/v2/intent/partner/add', params, { isAutoMsg: false })
/**
 * @desc 提交合伙人信息
 * @param {*} remark: 备注
 * @param {*} channel: 渠道
 * @param {*} shop: 是否开店
 * @param {*} industry: 行业
 * @param {*} address: 地址
 * @param {*} phone: 手机号
 * @param {*} province: 省份
 * @param {*} city: 城市
 * @param {*} join: 开店时间
 * @param {*} phone: 手机号
 * @param {*} token: token
 * @param {*} intent_type: 'rrc-openapi-partner'
 * @param {*} device: 设备
 * @returns
 */
export const submitPartnerInfo = params => post('/intent/ark/v1/intent/partner/extra', params, { isFormData: true, isAutoMsg: false })

/**
 * @desc 获取省份下城市
 * @param {*} province: 省份
 * @returns
 */
export const getCityList = params => get('/lurker/city/getCityByProvince', params, { isAutoMsg: false })
